import { render, staticRenderFns } from "./IconTypeformWebsite.vue?vue&type=template&id=64ddfd81&"
import script from "./IconTypeformWebsite.vue?vue&type=script&lang=ts&"
export * from "./IconTypeformWebsite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports